import { render, staticRenderFns } from "./BuyAccountInfo.vue?vue&type=template&id=b873b27c&scoped=true"
import script from "./BuyAccountInfo.vue?vue&type=script&lang=js"
export * from "./BuyAccountInfo.vue?vue&type=script&lang=js"
import style0 from "./BuyAccountInfo.vue?vue&type=style&index=0&id=b873b27c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b873b27c",
  null
  
)

export default component.exports